import { render, staticRenderFns } from "./lvbreadcrumb.vue?vue&type=template&id=3240712a&"
import script from "./lvbreadcrumb.vue?vue&type=script&lang=js&"
export * from "./lvbreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./lvbreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports